import { BaseService } from './base'
import { APIPath } from 'utility/constant'

class MetaData {
    getTimeZones() {
        return BaseService.get(`${APIPath.allTimeZones}`)
    }

    /** Curated timezone catalog for report send-time UI (GET /Timezones). */
    getReportTimeZones() {
        return BaseService.get(`${APIPath.timezones}`)
    }
}

const MetaDataService = new MetaData()
Object.freeze(MetaDataService)
export { MetaDataService }
